module.exports = __webpack_public_path__ + "public/images/step-3.1d28bc1f1d740edcd5833eba136920ae.png";